import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useRoles } from '../hooks/useRoles';
import './NavigationBar.css';
import { Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faMobileAlt,
    faBars,
    faTimes,
    faSignOutAlt,
    faFileLines,
    faUsers,
    faServer,
    faBuilding,
    faHome,
    faKey,
    faChartPie,
    faShieldHalved,
    faChevronDown,
    faLifeRing
} from '@awesome.me/kit-c57dd77961/icons/duotone/solid';

const NavigationBar: React.FC = () => {
    const { logout } = useAuth();
    const { isSiteAdmin, isAdmin } = useRoles();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isAdminOpen, setIsAdminOpen] = useState(false);
    const adminDropdownRef = useRef<HTMLDivElement>(null);
    const firstName = sessionStorage.getItem('firstName') || 'User';

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (adminDropdownRef.current && !adminDropdownRef.current.contains(e.target as Node)) {
                setIsAdminOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const closeMenus = () => {
        setIsAdminOpen(false);
        setIsMenuOpen(false);
    };

    const adminLinks = (
        <>
            { isSiteAdmin && (
                <Link to="/products" className="nav-link" onClick={closeMenus}>
                    <FontAwesomeIcon icon={faServer} className="nav-icon" /> Products
                </Link>
            )}
            { isAdmin && (
                <Link to="/users" className="nav-link" onClick={closeMenus}>
                    <FontAwesomeIcon icon={faUsers} className="nav-icon" /> Users
                </Link>
            )}
            { isSiteAdmin && (
                <>
                    <Link to="/signing-keys" className="nav-link" onClick={closeMenus}>
                        <FontAwesomeIcon icon={faKey} className="nav-icon" /> Signing Keys
                    </Link>
                    <Link to="/reports" className="nav-link" onClick={closeMenus}>
                        <FontAwesomeIcon icon={faChartPie} className="nav-icon" /> Reports
                    </Link>
                </>
            )}
        </>
    );

    return (
        <>
            <header className="navbar">
                <div className="navbar-left">
                    <div className="navbar-brand">
                        <Link to="/">
                            <img src="/logo.png" alt="Lakota Portal Logo" className="navbar-logo" aria-label="Lakota Portal Logo" />
                        </Link>
                    </div>
                    <nav className={`navbar-nav ${isMenuOpen ? 'open' : ''}`}>
                        <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                            <FontAwesomeIcon icon={faHome} className="nav-icon" /> Home
                        </Link>
                        <Link to="/licenses" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                            <FontAwesomeIcon icon={faMobileAlt} className="nav-icon" /> Licenses
                        </Link>
                        <Link to="/downloads" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                            <FontAwesomeIcon icon={faFileLines} className="nav-icon" /> Downloads
                        </Link>
                        <Link to="/support-tickets" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                            <FontAwesomeIcon icon={faLifeRing} className="nav-icon" /> Support
                        </Link>
                        { isSiteAdmin && (
                            <Link to="/customers" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                                <FontAwesomeIcon icon={faBuilding} className="nav-icon" /> Customers
                            </Link>
                        )}

                        {/* Desktop admin dropdown */}
                        { isAdmin && (
                            <div className="admin-dropdown-wrapper desktop-only" ref={adminDropdownRef}>
                                <button
                                    className="nav-link admin-dropdown-trigger"
                                    onClick={() => setIsAdminOpen(!isAdminOpen)}
                                >
                                    <FontAwesomeIcon icon={faShieldHalved} className="nav-icon" />
                                    Admin
                                    <FontAwesomeIcon
                                        icon={faChevronDown}
                                        className={`admin-chevron ${isAdminOpen ? 'open' : ''}`}
                                    />
                                </button>
                                { isAdminOpen && (
                                    <div className="admin-dropdown">
                                        {adminLinks}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Mobile admin section */}
                        { isAdmin && (
                            <div className="admin-section mobile-only">
                                <div className="admin-section-label">
                                    <FontAwesomeIcon icon={faShieldHalved} className="nav-icon" />
                                    Admin
                                </div>
                                {adminLinks}
                            </div>
                        )}

                        <div className="navbar-mobile-controls">
                            <ThemeToggle />
                            <button onClick={logout} className="logout-button" title="Logout">
                                <FontAwesomeIcon icon={faSignOutAlt} swapOpacity />
                            </button>
                        </div>
                    </nav>
                </div>
                <div className="navbar-user">
                    <span>Welcome, {firstName}</span>
                    <ThemeToggle />
                    <button onClick={logout} className="logout-button" title="Logout">
                        <FontAwesomeIcon icon={faSignOutAlt} swapOpacity />
                    </button>
                    <button className="hamburger-button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} swapOpacity />
                    </button>
                </div>
            </header>
        </>
    );
};

export default NavigationBar;
